module.exports = __webpack_public_path__ + "static/img/icone-reborn.71c5687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icone-reborn.png
// module id = hlLO
// module chunks = 0